import {useEffect} from 'react'
import {auth} from '../Auth'
import {store} from './reducer'
import DB from '../DAL/DB'
import FormArchives from '../DAL/FormArchives'
import { getDoc, getDocs, collection } from 'firebase/firestore'

const scoringSystems = new DB.ScoringSystems()

export function useSubscriptions(archiveId) {
  useEffect(() => {
    if (!archiveId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const docSnap = await getDoc(formArchives.docRef(archiveId))
      if (docSnap.exists()) store.dispatch({type: 'form', value: {id: docSnap.id, ...docSnap.data()}})

      const ssSnap = await scoringSystems.get(undefined, {
        filters: [['organization.id', '==', auth.sunkaizenUser.organization.id]],
      })
      if (ssSnap?.ok) {
        store.dispatch({type: 'scoringSystems', value: ssSnap.data})
      }

      const rubricsSnap = await getDocs(collection(formArchives.docRef(archiveId), 'rubrics'))
      const rMap = {}
      rubricsSnap.docs.forEach((d) => {
        rMap[d.id] = {id: d.id, ...d.data()}
      })
      store.dispatch({type: 'rubrics', value: rMap})
    }
    fetch()
  }, [archiveId])
}
